export default "__VITE_ASSET__C1_AW_sK__"